// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyC3Z02gtPRQ_38aFEwdNZNalZHj8upezY4",
  authDomain: "rrath-rrath.firebaseapp.com",
  projectId: "rrath-rrath",
  storageBucket: "rrath-rrath.appspot.com",
  databaseURL: "https://rrath-rrath-default-rtdb.firebaseio.com/",
  messagingSenderId: "433995017502",
  appId: "1:433995017502:web:f00e7d6234797cd9cf6d0f",
  measurementId: "G-QYXKGVQ69N",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
